export const getAuthorsName = (id: number): string => {
  switch (id) {
    case 2:
      return "Claire-Marine Beha"
    default:
      return "Claire-Marine Beha"
  }
}
